export enum AppLang {
  en = 'en',
  ru = 'ru',
}
